<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12DpbF4/tc-custom/9781913682897.jpg?1728725562512" alt="This image is the cover for the book Girl in His Eyes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Girl in His Eyes
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Abused as a child, a woman believes her father is grooming a new victim in this dark psychological drama from the author of <i>Blind Side</i>.</b></p><p><b> </b>Laura, a young woman struggling to deal with what her father did to her a decade ago, is horrified to realize that the girl he takes swimming might be his next victim. Emma is twelve—the age Laura was when her father took away her innocence.</p><p>Intimidated by her father’s rages, Laura has never told anyone the truth about her childhood. Now she must decide whether she has the courage to expose him and face the consequences.</p><p>Can Laura overcome her fear and save Emma before the worst happens?</p><p><b>Praise for Jennie Ensor</b></p> “Ensor’s writing is graceful, poetic, intelligent, and captivating. She builds suspense brilliantly.” —Gail Cleare, <i>USA Today</i>–bestselling author
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennie Ensor
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2f463186